<template>
  <div @click="onClick" class="like-button">
    <span class="like-types">{{ likesIcons }}</span>
    <span class="like-count">{{ likes.length }}</span>
    <span v-if="showLabel">{{ $tc('post.likePost.likes', likes.length) }}</span>
  </div>
</template>

<script>
import LikeService from '../../service/like.service'

export default {
  name: 'UserLikesButton',
  props: {
    likes: {
      // { type, idUser }
      type: Array,
      default: () => []
    },
    showLabel: {
      type: Boolean,
      default: false
    },
    onClick: {
      type: Function,
      required: true
    }
  },
  computed: {
    likesIcons() {
      return LikeService.getLikesIcons(this.likes).join('')
    }
  }
}
</script>

<style scoped lang="scss">
.like-button {
  cursor: pointer;

  .like-types {
    letter-spacing: -5px;
  }

  .like-count {
    margin-right: 5px;
    margin-left: 10px;
    font-weight: bold;
  }
}
</style>
